const pluginVersion = "12.0.0";
const defaultOptions = {
  selectedSeries: 0
};

export { defaultOptions, pluginVersion };
